<template>
  <div>
    <div class="fullview">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <p class="text-dark">
              お支払い金額 {{ this.$store.state.cardPayment.prop.price }}円
            </p>
          </div>
        </div>
        <div class="row m-0 p-0 align-items-center" style="overflow-y: scroll; height: 370px;">
          <div class="col d-flex flex-column" style="height:">
            <stripe-element-payment
              ref="paymentRef"
              :pk="pk"
              :elements-options="elementsOptions"
              :confirm-params="confirmParams"
              :redirect="redirect"
              @confirmed="cardProcess"
              v-if="showForm"
            />
          </div>
        </div>
        <div
          class="d-flex flex-row justify-content-center gap-5 mt-auto mb-5"
          v-if="showForm"
        >
          <button
            class="outline-btn mt-3"
            style="width: 150px"
            @click="cancelAction"
          >
            キャンセル
          </button>
          <button class="acry-btn mt-3 fw-bold" style="width:150px; height:40px; border-radius: 40px; rihgt:10px; right: 18px;" :disabled="payBtnDisabled"  @click="pay">
            支払う
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
import firebase from "firebase/app";
import { User } from "@/js/User.js";
import config from 'config'

/*
参考
https://docs.vuestripe.com/vue-stripe/stripe-elements/payment
スタイル
https://stripe.com/docs/elements/appearance-api

*/
export default {
  name: "CardPayment_Ap",
  components: {
    StripeElementPayment,
  },
  data() {
    return {
      payBtnDisabled:false,
      pk:
      config.isDebug?
        "pk_test_51NLKJPDL1zHWgBtX4zBR07IkcrL462XbYZ2HQK4offwlx0VDbdhxEJYXJUho4VuKeQ2n2BWmHqX2ZFPg1oV54RcC00uxNDyFmD":
        "pk_live_51NLKJPDL1zHWgBtXK8j3LRsBzwxH9Z70FxJFZWDkn2pRasiczPBV58O826IMBM8Xwumcklyaazn7u8UEEsmx4vbh00zLC8B3ZS",
      elementsOptions: {
        appearance: {
          theme: "Default",
          // variables: {
          //   fontFamily: ' "Gill Sans", sans-serif',
          //   fontLineHeight: "1.5",
          //   borderRadius: "10px",
          //   colorBackground: "#F6F8FA",
          //   colorPrimaryText: "#262626",
          // },
          // rules: {
          //   ".Block": {
          //     backgroundColor: "var(--colorBackground)",
          //     boxShadow: "none",
          //     padding: "12px",
          //   },
          //   ".Input": {
          //     padding: "12px",
          //   },
          //   ".Input:disabled, .Input--invalid:disabled": {
          //     color: "lightgray",
          //   },
          //   ".Tab": {
          //     padding: "10px 12px 8px 12px",
          //     border: "none",
          //   },
          //   ".Tab:hover": {
          //     border: "none",
          //     boxShadow:
          //       "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
          //   },
          //   ".Tab--selected, .Tab--selected:focus, .Tab--selected:hover": {
          //     border: "none",
          //     backgroundColor: "#fff",
          //     boxShadow:
          //       "0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)",
          //   },
          //   ".Label": {
          //     fontWeight: "500",
          //   },
          // },
        }, // appearance options
      },
      redirect: "if_required",
      confirmParams: {
        return_url: "", // success url
      },
      showForm: false,
    };
  },
  async mounted() {
    this.$store.commit("showLoading");
    await this.generatePaymentIntent();
    this.$store.commit("hideLoading");
  },
  methods: {
    async generatePaymentIntent() {
      const functions = firebase.functions();
      const inte = functions.httpsCallable("AcryproStripePaymentIntent");

      const result = await inte({
        email: User.userData.email,
        amount: this.$store.state.cardPayment.prop.price,
        orderId: this.$store.state.cardPayment.prop.orderId,
        uid: firebase.auth().currentUser.uid,
      });
      this.elementsOptions.clientSecret = result.data.paymentIntent;
      this.showForm = true;
    },
    pay() {
      this.$refs.paymentRef.submit();
    },
    cancelAction() {
      this.$store.commit("hideCardPayment");
    },
    cardProcess() {
      this.$store.state.cartManager.deleteAll().then(() => {
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "注文を受け付けました。");
        if( this.$store.state.cardPayment.callback ){
          this.$store.state.cardPayment.callback();
        }
        this.$store.commit("hideCardPayment");
      });
    },
  },
};
</script>

<style scoped lang="scss">
.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;

  display: flex;
  align-items: center;
  justify-content: center;
}
.container-fluid {
  margin-right: auto;
  margin-left: auto;
  max-width: 600px;
  min-width: 600px;
  max-height: 500px;
  min-height: 500px;
  width: 600px;
  height: 500px;
  z-index: 10001;
  padding: 1em;
  background-color: white;
}
.outline-btn {
  width: 250px;
  height:40px;
  border:3px solid $primary-main-color;
  color:$primary-main-color;
  border-radius: 20px;
  margin-top: 1px;
  background-color: white;
  font-weight: bold;
}
</style>
